import {MaterialConnection} from "#material/nodes/base/connection/material-connection"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import {concatPath} from "@cm/graph-v3"
import {isClass} from "@cm/utils/misc"

// note that traversal order is not guaranteed
// it may change when the graph is deserialized/cloned etc.
export const deepTraverseMaterialNodeParameters = (rootNode: unknown, callback?: (node: MaterialNode | MaterialConnection<any>, path: string) => void) => {
    const collectedIds = new Set<string>([])
    const traverseParameter = (parameter: unknown, path: string): void => {
        if (parameter instanceof MaterialNode) {
            if (!collectedIds.has(parameter.id)) {
                callback?.(parameter, path)
                collectedIds.add(parameter.id)
            }
            traverseParameter(parameter.parameters, concatPath(path, parameter.nodeClass))
        } else if (parameter instanceof MaterialConnection) {
            if (!collectedIds.has(parameter.id)) {
                callback?.(parameter, path)
                collectedIds.add(parameter.id)
            }
            traverseParameter(parameter.parameters.value, concatPath(path, parameter.parameters.key))
        } else if (typeof parameter === "object" && parameter) {
            if (parameter instanceof Array) {
                parameter.forEach((entry, index) => traverseParameter(entry, concatPath(path, index)))
            } else if (isClass(parameter)) {
                // nothing to do
            } else
                Object.entries(parameter).forEach(([key, value]) => {
                    traverseParameter(value, concatPath(path, key))
                }, {})
        }
    }

    traverseParameter(rootNode, "")
}
